import { Container, Row } from "reactstrap";
import AbsolutePrimary from "./AbsolutePrimary";
import AbsoluteSecondary from "./AbsoluteSecondary";
import BorderBottom from "./BorderBottom";
import BorderLeft from "./BorderLeft";
import BorderPrimary from "./BorderPrimary";
import BorderRight from "./BorderRight";
import BorderSecondary from "./BorderSecondary";
import BorderTop from "./BorderTop";
import BorderWarning from "./BorderWarning";
import { Breadcrumbs } from "../../../AbstractElements";
import { BonusUi, CreativeCardTitle } from "../../../Constants/Constants";

const CreativeCardContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={CreativeCardTitle} parent={BonusUi} />
      <Container fluid className="effective-card">
        <Row>
          <BorderLeft />
          <BorderRight />
          <BorderTop />
          <BorderBottom />
          <BorderPrimary />
          <BorderWarning />
          <BorderSecondary />
          <AbsolutePrimary />
          <AbsoluteSecondary />
        </Row>
      </Container>
    </>
  );
};
export default CreativeCardContainer;
